import { AITraits } from "../aiHelpers";

export default {} as Record<string, AITraits<any>>;
